<template>
    <!-- eslint-disable -->
    <div class="col-md-12 col-lg-12 mobile_pr_15 payment_shipment_new_page">
        <div
            class="white_box py_52 px_50 shipping_fl_left payment-shipment-mg card-shipping"
        >
            <h1 class="heading1 mb_32">3. Payment & Shipment</h1>
            <form
                method="post"
                @submit.prevent="payViaCard"
                data-vv-scope="shippingandpaymentform"
                class="f_fl_left"
            >
                <div class="payment_method" v-if="!isAdminLoggedIn">
                    <div
                        class="radio_butoons_headding d-flex mt_0 border-top-0 border-bottom"
                        v-for="(payment_methods, indx) in all_payment_methods"
                        :key="indx"
                        :style="
                            payment_methods.expired_time < new Date()
                                ? 'display:none !important'
                                : ''
                        "
                    >
                        <p class="m-0">
                            <input
                                type="radio"
                                :value="
                                    payment_methods.customerPaymentProfileId
                                "
                                :id="payment_methods.customerPaymentProfileId"
                                name="radio-group"
                                @change="
                                    singlePaymentMethod(
                                        payment_methods.customerPaymentProfileId,
                                        payment_methods.expired_time,
                                        $event
                                    )
                                "
                            />
                            <label
                                :for="payment_methods.customerPaymentProfileId"
                                class="m-0"
                            >
                                **** **** ****
                                <span class="cc_opa">
                                    {{
                                        payment_methods.payment.creditCard
                                            .cardNumber
                                            ? payment_methods.payment.creditCard.cardNumber.substr(
                                                  -4
                                              )
                                            : ""
                                    }}
                                </span>
                            </label>
                        </p>

                        <div
                            class="ml-auto mr_6 cards_img"
                            v-if="
                                payment_methods.payment.creditCard.cardType ==
                                'Visa'
                            "
                        >
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/add_visa_logo.png'
                                "
                                alt=" "
                            />
                        </div>

                        <div
                            class="ml-auto mr_6 cards_img"
                            v-else-if="
                                payment_methods.payment.creditCard.cardType ==
                                'MasterCard'
                            "
                        >
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/master_card_logo.png'
                                "
                                alt=" "
                            />
                        </div>

                        <div
                            class="ml-auto mr_6 cards_img"
                            v-else-if="
                                payment_methods.payment.creditCard.cardType ==
                                'JCB'
                            "
                        >
                            <img
                                :src="base_url + '/maincss/images/jcb_logo.svg'"
                                alt=" "
                            />
                        </div>

                        <div
                            class="ml-auto mr_6 cards_img"
                            v-else-if="
                                payment_methods.payment.creditCard.cardType ==
                                'Discover'
                            "
                        >
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/discover_logo.svg'
                                "
                                alt=" "
                            />
                        </div>

                        <div
                            class="ml-auto mr_6 cards_img"
                            v-else-if="
                                payment_methods.payment.creditCard.cardType ==
                                'AmericanExpress'
                            "
                        >
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/american_express_logo.svg'
                                "
                                alt=" "
                            />
                        </div>

                        <div class="ml-auto mr_6 cards_img" v-else>
                            <img
                                :src="
                                    base_url +
                                    '/maincss/images/unknown_card_logo.svg'
                                "
                                alt=" "
                            />
                        </div>
                    </div>

                    <div
                        class="card-pay radio_butoons_headding d-flex mt_0 border-top-0 border-bottom"
                    >
                        <a
                            href="javascript:void(0);"
                            class="payment_box d-flex justify-content-center align-items-center flex-column text-center h-100"
                            data-keyboard="false"
                            data-toggle="modal"
                            data-target="#add_payment_method_model"
                            data-dismiss="modal"
                        >
                            <a><b>+ Add New Card </b></a>
                        </a>
                        <img
                            src="/maincss/images/cards.png"
                            alt=" "
                            class="ml-auto mr_6 cards_img"
                        />
                    </div>

                    <div>
                        <div class="two_input_one_row mt_36 payment_bottom">
                            <div class="form-group card-no">
                                <input
                                    v-if="order_data.is_saved_card"
                                    type="text"
                                    class="form-control"
                                    id="Card Number"
                                    name="CardNumber"
                                    placeholder="Enter Card Number "
                                    :value="
                                        '#### #### #### ' +
                                        order_data.cardnumber
                                    "
                                    v-validate="
                                        order_data.is_pay_way_terms != 1
                                            ? 'required|length:19'
                                            : ''
                                    "
                                    data-vv-as="Card Number"
                                    :disabled="order_data.is_saved_card"
                                />
                                <input
                                    v-else
                                    type="text"
                                    class="form-control"
                                    id="Card Number"
                                    name="CardNumber"
                                    placeholder="Enter Card Number "
                                    v-model="order_data.cardnumber"
                                    v-validate="
                                        order_data.is_pay_way_terms != 1
                                            ? 'required|min:17|max:19'
                                            : ''
                                    "
                                    data-vv-as="Card Number"
                                    :disabled="!order_data.is_saved_card"
                                    v-mask="
                                        masklength == null
                                            ? '#### #### #### #'
                                            : masklength == 14
                                            ? '#### #### #### ##'
                                            : masklength == 15
                                            ? '#### ###### #####'
                                            : masklength == 16
                                            ? '#### #### #### ####'
                                            : masklength == 17
                                            ? '#### #### #### ####'
                                            : '#### #### #### ####'
                                    "
                                    @input="cardNumberFormate"
                                />
                                <label>Card number</label>
                                <span class="highlight"></span>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="
                                        errors.has(
                                            'shippingandpaymentform.CardNumber'
                                        )
                                    "
                                >
                                    {{
                                        errors.first(
                                            "shippingandpaymentform.CardNumber"
                                        )
                                    }}
                                </small>
                            </div>

                            <div
                                class="form-group position-relative expiration"
                                style="width: 60px"
                            >
                                <label class="select_option_label">Month</label>
                                <select
                                    class="form-control bg-transparent"
                                    v-model="order_data.cardexpiremonth"
                                    name="Expiration Month"
                                    v-validate="'required'"
                                    data-vv-as="Expiration Month"
                                    :disabled="
                                        order_data.is_saved_card ||
                                        !order_data.is_saved_card
                                    "
                                >
                                    <option
                                        v-for="n in 12"
                                        :value="10 > n ? '0' + n : n"
                                        :key="n"
                                        :disabled="
                                            n < new Date().getMonth() + 1 &&
                                            changedYear <= currentYear
                                        "
                                    >
                                        {{ 10 > n ? "0" + n : n }}
                                    </option>
                                </select>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="
                                        errors.has(
                                            'shippingandpaymentform.Expiration Month'
                                        )
                                    "
                                >
                                    {{
                                        errors.first(
                                            "shippingandpaymentform.Expiration Month"
                                        )
                                    }}
                                </small>
                            </div>
                            <div
                                class="form-group position-relative expiration"
                                style="width: 60px"
                            >
                                <label class="select_option_label">Year</label>
                                <select
                                    class="form-control bg-transparent"
                                    v-model="order_data.cardexpireyear"
                                    name="Expiration Year"
                                    v-validate="'required'"
                                    data-vv-as="Expiration Year"
                                    :disabled="
                                        order_data.is_saved_card ||
                                        !order_data.is_saved_card
                                    "
                                    @change="changeCardYear($event)"
                                >
                                    <option
                                        v-for="year in years"
                                        :key="year"
                                        :value="
                                            year
                                                ? year.toString().substr(-2)
                                                : ''
                                        "
                                    >
                                        {{ year }}
                                    </option>
                                </select>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="
                                        errors.has(
                                            'shippingandpaymentform.Expiration Year'
                                        )
                                    "
                                >
                                    {{
                                        errors.first(
                                            "shippingandpaymentform.Expiration Year"
                                        )
                                    }}
                                </small>
                            </div>
                            <div class="form-group securit_code">
                                <input
                                    maxlength="3"
                                    type="text"
                                    class="form-control"
                                    id="Security Code"
                                    placeholder="Enter Code"
                                    name="Security Code"
                                    v-model="order_data.cardsecuritycode"
                                    v-validate="
                                        order_data.is_pay_way_terms != 1 &&
                                        order_data.is_cod != 1 &&
                                        order_data.is_pay_later != 1
                                            ? 'required|numeric|length:3'
                                            : ''
                                    "
                                    @input="cardSecurityFormate"
                                    :disabled="!order_data.is_saved_card"
                                />
                                <label>Security code</label>
                                <div
                                    class="alert-icon pb-2"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    v-tooltip="'Credit Card Security Code'"
                                >
                                    <img
                                        src="/maincss/images/information.svg"
                                        alt=" "
                                    />
                                </div>
                                <span class="highlight"></span>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="
                                        errors.has(
                                            'shippingandpaymentform.Security Code'
                                        )
                                    "
                                >
                                    {{
                                        errors.first(
                                            "shippingandpaymentform.Security Code"
                                        )
                                    }}
                                </small>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="
                            order_data.credit_limit > 0 &&
                            (!isAdminLoggedIn ||
                                (grand_total_price ||
                                    parseFloat(order_data.grand_total || 0) +
                                        parseFloat(shipping_price || 0)) <=
                                    parseFloat(
                                        termPaymentInfo.avalaible_on_account ||
                                            0
                                    ))
                        "
                        class="radio_butoons_headding pay_via_terms_box d-flex mt_16 border-top-0 border-bottom"
                    >
                        <div class="position-relative">
                            <p class="m-0">
                                <input
                                    type="radio"
                                    value="1"
                                    v-model="order_data.is_payvia_terms"
                                    id="test2"
                                    name="radio-group"
                                />
                                <label for="test2" class="m-0"
                                    ><span class="cc_opa"
                                        >Pay via terms</span
                                    ></label
                                >
                            </p>
                            <div
                                class="alert-icon pb-2"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                v-tooltip="'Pay via terms'"
                            >
                                <img
                                    src="/maincss/images/information.svg"
                                    alt=" "
                                />
                            </div>
                        </div>

                        <span
                            class="text-right ml-auto mr_6 cards_img font-weight-bold heading5"
                            >${{ order_data.credit_limit }}</span
                        >
                    </div>
                </div>

                <div
                    v-if="
                        termPaymentInfo &&
                        parseFloat(termPaymentInfo.avalaible_on_account || 0) >
                            0
                    "
                    class="payment_method mt_14"
                >
                    <h3 class="shipping-options-title mb_16">Payment Method</h3>
                    <div class="new_add_card_payment_method_block">
                        <div
                            class="radio_butoons_headding d-flex border-top-0 border-bottom"
                        >
                            <!-- <p class="m-0">
                                <input
                                    type="radio"
                                    id="paylater"
                                    :value="true"
                                    v-model="order_data.is_pay_later"
                                    name="radio-group"
                                     @click="selectPaymentOption('pay_later')"
                                />
                                <label for="paylater" class="m-0">Pay via terms</label>
                                <img
                                    src="/maincss/images/info.svg"
                                    alt=" "
                                    class="info-icon"
                                />
                            </p> -->
                            <div
                                class="shipping-options-section new_payment_method_radio_button"
                            >
                                <div class="shipping-options-radio-group">
                                    <label
                                        for="payviaterms"
                                        class="shipping-option-label"
                                    >
                                        <input
                                            type="radio"
                                            id="payviaterms"
                                            :value="true"
                                            v-model="
                                                order_data.is_pay_way_terms
                                            "
                                            name="radio-group"
                                            @click="
                                                selectPaymentOption(
                                                    'pay_way_terms'
                                                )
                                            "
                                        />
                                        <span class="radio-text"
                                            >Pay via terms</span
                                        >
                                    </label>
                                    <img
                                        src="/maincss/images/info.svg"
                                        alt=" "
                                        class="info-icon"
                                    />
                                </div>
                            </div>
                            <h4 class="payment-amount_via">
                                {{
                                    icPriceFormat(
                                        termPaymentInfo.avalaible_on_account ||
                                            0
                                    )
                                }}
                            </h4>
                            <img
                                style="visibility: hidden"
                                src="/maincss/images/paypal.png"
                                alt=" "
                                class="ml-auto mr_6 d-none"
                            />
                        </div>
                    </div>
                </div>
                <div
                    class="payment_method mt_16 new_payment_send_link_block"
                    v-if="isAdminLoggedIn"
                >
                    <!-- <p class="m-0 d-none">
                        <input
                            type="radio"
                            id="paylater"
                            :value="true"
                            v-model="order_data.is_pay_later"
                            name="radio-group"
                             @click="selectPaymentOption('pay_later')"
                        />
                        <label for="paylater" class="m-0">Send Payment Link</label>
                    </p> -->
                    <div
                        class="shipping-options-section new_payment_method_radio_button"
                    >
                        <div class="shipping-options-radio-group">
                            <label
                                for="sendpaymentlink"
                                class="shipping-option-label"
                            >
                                <input
                                    type="radio"
                                    id="sendpaymentlink"
                                    :value="true"
                                    v-model="order_data.is_pay_later"
                                    name="radio-group"
                                    @click="selectPaymentOption('pay_later')"
                                />
                                <span class="radio-text"
                                    >Send Payment Link</span
                                >
                            </label>
                        </div>
                    </div>
                </div>
                <div class="payment_method mt_14" style="display: none">
                    <div>
                        <div
                            class="radio_butoons_headding d-flex border-top-0 border-bottom"
                        >
                            <p class="m-0">
                                <input
                                    type="radio"
                                    id="cod"
                                    :value="1"
                                    v-model="order_data.is_cod"
                                    name="radio-group"
                                    @click="selectPaymentOption('cod')"
                                />
                                <label for="cod" class="m-0">COD</label>
                            </p>
                            <img
                                style="visibility: hidden"
                                src="/maincss/images/paypal.png"
                                alt=" "
                                class="ml-auto mr_6"
                            />
                        </div>
                    </div>
                </div>

                <div class="payment_method mt_14">
                    <div style="display: none">
                        <div
                            class="radio_butoons_headding d-flex border-top-0 border-bottom"
                        >
                            <p class="m-0">
                                <input
                                    type="radio"
                                    id="test2"
                                    value="1"
                                    v-model="order_data.is_paypal"
                                    name="radio-group"
                                />
                                <label for="test2" class="m-0">Paypal</label>
                            </p>
                            <img
                                src="/maincss/images/paypal.png"
                                alt=" "
                                class="ml-auto mr_6"
                            />
                        </div>
                    </div>
                </div>

                <!-- TERM PAYMENT -->
                <div
                    class="coupon mt_32"
                    v-if="
                        parseFloat(termPaymentInfo.creditlimit) > 0 &&
                        isAdminLoggedIn
                    "
                >
                    <div class="row align-items-end">
                        <div class="col-md-12 col-lg-12 col-xlg-9">
                            <div id="accordion">
                                <div class="form-check p-0 pay-terms">
                                    <div
                                        class="pay card-pay radio_butoons_headding d-flex mt_0 border-top-0 border-bottom pay_way"
                                    >
                                        <div
                                            class="label-popup"
                                            aria-expanded="true"
                                            aria-controls="payWayTerms"
                                        >
                                            <input
                                                class="form-check-input"
                                                type="radio"
                                                :checked="
                                                    order_data.is_pay_way_terms
                                                "
                                                @click="
                                                    selectPaymentOption(
                                                        'pay_way_terms'
                                                    )
                                                "
                                                name="radio-group"
                                                value=""
                                                id="flexCheck"
                                            />
                                            <label
                                                class="form-check-label"
                                                for="flexCheck"
                                            >
                                                Pay with terms
                                                <img
                                                    src="/maincss/images/information.svg"
                                                    alt=" "
                                                />
                                            </label>
                                            <span
                                                class="term-amount"
                                                v-if="
                                                    termPaymentInfo.creditlimit
                                                "
                                                >{{
                                                    icPriceFormat(
                                                        termPaymentInfo.creditlimit
                                                    )
                                                }}</span
                                            >
                                            <span class="term-amount" v-else>{{
                                                icPriceFormat(0)
                                            }}</span>
                                        </div>
                                    </div>
                                    <div
                                        id="payWayTerms"
                                        class="collapse"
                                        :class="{
                                            show:
                                                order_data.is_pay_way_terms == 1
                                        }"
                                        aria-labelledby="headingOne"
                                        data-parent="#accordion"
                                    >
                                        <div class="pay-box">
                                            <div class="balance-box">
                                                <h5>Credit Limit:</h5>
                                                <h3
                                                    v-if="
                                                        termPaymentInfo.creditlimit
                                                    "
                                                >
                                                    {{
                                                        icPriceFormat(
                                                            termPaymentInfo.creditlimit
                                                        )
                                                    }}
                                                </h3>
                                                <h3 v-else>
                                                    {{ icPriceFormat(0) }}
                                                </h3>
                                            </div>

                                            <div class="balance-block">
                                                <div class="odered-balance">
                                                    <h5>Unpaid Invoices:</h5>
                                                    <h3
                                                        class="text-danger"
                                                        v-if="
                                                            termPaymentInfo.unpaid_invoices
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                termPaymentInfo.unpaid_invoices
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3
                                                        class="text-danger"
                                                        v-else
                                                    >
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>Overdue balance:</h5>
                                                    <h3
                                                        :class="{
                                                            'text-danger':
                                                                termPaymentInfo.overdue_balance <
                                                                0
                                                        }"
                                                        v-if="
                                                            termPaymentInfo.overdue_balance
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                termPaymentInfo.overdue_balance
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3 v-else>
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>Unbilled Orders:</h5>
                                                    <h3
                                                        class="text-danger"
                                                        v-if="
                                                            termPaymentInfo.unbilled_orders
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                termPaymentInfo.unbilled_orders
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3
                                                        class="text-danger"
                                                        v-else
                                                    >
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>Unapplied Credits:</h5>
                                                    <h3
                                                        :class="{
                                                            'text-danger':
                                                                term_payment_info.unapplied_credits <
                                                                0
                                                        }"
                                                        v-if="
                                                            termPaymentInfo.unapplied_credits
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                termPaymentInfo.unapplied_credits
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3 v-else>
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>
                                                        Available on Account:
                                                    </h5>
                                                    <h3
                                                        :class="{
                                                            'text-danger':
                                                                termPaymentInfo.avalaible_on_account <
                                                                0
                                                        }"
                                                        v-if="
                                                            termPaymentInfo.avalaible_on_account
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                termPaymentInfo.avalaible_on_account
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3 v-else>
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>Current Order:</h5>
                                                    <h3 class="text-danger">
                                                        {{
                                                            icPriceFormat(
                                                                order_data.order_price
                                                            )
                                                        }}
                                                    </h3>
                                                </div>
                                            </div>

                                            <div class="balance-box">
                                                <h5>Available Credit:</h5>
                                                <h3
                                                    v-if="
                                                        termPaymentInfo.avalaible_on_account
                                                    "
                                                >
                                                    {{
                                                        icPriceFormat(
                                                            termPaymentInfo.avalaible_on_account -
                                                                order_data.order_price
                                                        )
                                                    }}
                                                </h3>
                                                <h3 v-else>
                                                    {{ icPriceFormat(0) }}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="coupon mt_32">
                    <div class="row align-items-end">
                        <div class="col-md-12 col-lg-12 col-xlg-9">
                            <p class="mb-0 font_size_14 new_comm_field_title">
                                PO number ( Optional )
                            </p>
                            <div class="d-flex coupon">
                                <div class="form-group mt-1 ml-0 w-100">
                                    <input
                                        type="text"
                                        placeholder="Enter PO number"
                                        class="form-control"
                                        v-model="po_number"
                                    />
                                    <span class="highlight"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt_32">
                    <div class="col-md-12 col-lg-6">
                        <p class="mb-0 font_size_14 new_comm_field_title">
                            Shipment Carrrier
                        </p>
                        <select
                            class="form-control"
                            v-model="order_data.shippingproviderid"
                            @change="onShippingCarrierChange"
                        >
                            <option value="">Select Carrier</option>
                            <option
                                v-for="carrier in shippingCarriers"
                                :key="carrier.id"
                                :value="carrier.id"
                            >
                                {{ carrier.shpping_provider || carrier.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-12 col-lg-6">
                        <p class="mb-0 font_size_14 new_comm_field_title">
                            Shipping Methods
                        </p>
                        <select
                            class="form-control"
                            v-model="selected_shiping_method"
                            @change="calculateShipping"
                            :disabled="
                                !shipping_methods ||
                                shipping_methods.length === 0
                            "
                        >
                            <option :value="null">
                                Select Shipping Method
                            </option>
                            <option
                                v-for="method in shipping_methods"
                                :key="method.serviceName || method.serviceType"
                                :value="method"
                            >
                                {{ method.serviceName || method.serviceType }}
                                ({{
                                    icPriceFormat(
                                        method.total ||
                                            method.totalNetCharge ||
                                            0
                                    )
                                }})
                            </option>
                        </select>
                    </div>
                </div>
                <div class="gifts_cards" v-if="false">
                    <div class="row align-items-end">
                        <div class="col-md-12 col-lg-9 col-xlg-9">
                            <div id="accordion">
                                <div
                                    class="form-check p-0 add-gift-code collapsed"
                                >
                                    <div
                                        class="choice-gift"
                                        data-toggle="collapse"
                                        data-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="flexCheckDefault"
                                        />
                                        <div class="label-popup">
                                            <label
                                                class="form-check-label"
                                                for="flexCheckDefault"
                                            >
                                                Add gift card codes one at a
                                                time
                                            </label>
                                        </div>
                                    </div>
                                    <div
                                        id="collapseOne"
                                        class="collapse"
                                        aria-labelledby="headingOne"
                                        data-parent="#accordion"
                                    >
                                        <div class="d-flex add-gift-block">
                                            <div class="d-md-flex gift_card">
                                                <div
                                                    class="form-group ml-0 gift_card_number"
                                                >
                                                    <input
                                                        type="text"
                                                        v-model="
                                                            order_data.giftcardnumber
                                                        "
                                                        placeholder="Gift card number"
                                                        value=""
                                                        class="form-control"
                                                        v-on:change="
                                                            (event) =>
                                                                setGiftCardNumber(
                                                                    event
                                                                )
                                                        "
                                                    />
                                                    <span
                                                        class="highlight"
                                                    ></span>
                                                </div>

                                                <div
                                                    class="form-group enter_pin ml-auto"
                                                >
                                                    <input
                                                        type="text"
                                                        v-model="
                                                            order_data.giftcardpin
                                                        "
                                                        placeholder="Enter PIN  "
                                                        value=""
                                                        class="form-control"
                                                        v-on:change="
                                                            (event) =>
                                                                setGiftCardPin(
                                                                    event
                                                                )
                                                        "
                                                    />
                                                    <span
                                                        class="highlight"
                                                    ></span>

                                                    <div
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        v-tooltip="
                                                            'Gift Card Number'
                                                        "
                                                        class="alert-icon pb-2"
                                                        data-original-title="Tooltip on bottom"
                                                    >
                                                        <img
                                                            src="/maincss/images/information.svg"
                                                            alt=" "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-12 col-lg-3 col-xlg-3 text-xlg-right add_btn"
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn_outline_primary border_primary_blue text_primary_blue ml-auto py_10 px_42 mt-4 mt-xlg-0"
                                                    >ADD</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="coupon mt_20" v-if="false">
                    <div class="row align-items-end">
                        <div class="col-md-12 col-lg-9 col-xlg-9">
                            <div id="accordion">
                                <div
                                    class="form-check p-0 add-gift-code collapsed"
                                >
                                    <div class="choice-gift">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="flexCheckcoupon"
                                        />
                                        <div
                                            class="label-popup"
                                            data-toggle="collapse"
                                            data-target="#collapseTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseTwo"
                                        >
                                            <label
                                                class="form-check-label"
                                                for="flexCheckcoupon"
                                            >
                                                Apply a Coupon Code
                                            </label>
                                        </div>
                                    </div>

                                    <div
                                        id="collapseTwo"
                                        class="collapse"
                                        aria-labelledby="headingTwo"
                                        data-parent="#accordion"
                                    >
                                        <div class="d-flex coupon-block">
                                            <div class="d-flex coupon w-100">
                                                <div
                                                    class="form-group ml-0 w-100"
                                                >
                                                    <input
                                                        type="text"
                                                        v-model="
                                                            order_data.couponcode
                                                        "
                                                        placeholder="Enter code"
                                                        value=""
                                                        class="form-control"
                                                        v-on:change="
                                                            (event) =>
                                                                setCouponCode(
                                                                    event
                                                                )
                                                        "
                                                    />
                                                    <span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-12 col-lg-3 col-xlg-3 text-xlg-right add_btn"
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn_outline_primary border_primary_blue text_primary_blue ml-auto py_10 px_34"
                                                    >Apply</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="coupon mt_24 new_special_comments_block">
                    <div class="row align-items-end">
                        <div class="col-md-12 col-lg-12 col-xlg-9">
                            <div id="accordion">
                                <div class="form-check comment-box collapsed">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id="flexCheckComment"
                                        data-toggle="collapse"
                                        data-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    />
                                    <div class="label-popup">
                                        <label
                                            class="form-check-label"
                                            for="flexCheckComment"
                                        >
                                            Any Special Comments
                                        </label>
                                    </div>

                                    <div
                                        id="collapseThree"
                                        class="collapse"
                                        aria-labelledby="headingThree"
                                        data-parent="#accordion"
                                    >
                                        <div class="d-flex coupon">
                                            <div
                                                class="form-group ml-0 w-100 comment-text"
                                            >
                                                <textarea
                                                    class="form-control mb_0 special_cmt_textarea any_special_comments_area"
                                                    placeholder="Enter Comments here"
                                                    v-model="
                                                        order_data.specialcomment
                                                    "
                                                    v-on:change="
                                                        (event) =>
                                                            setSpecialComment(
                                                                event
                                                            )
                                                    "
                                                >
                                                </textarea>
                                                <span class="highlight"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt_36 d-none">
                    <button
                        v-if="order_data.is_pay_way_terms == 1"
                        type="button"
                        @click="payViaTerms()"
                        class="btn btn_orange bg_primary_orange text_white d-block mt_36 py_22"
                        style="width: 100%; max-width: 100%"
                    >
                        Review & Pay
                    </button>
                    <button
                        v-else
                        type="submit"
                        class="btn btn_orange bg_primary_orange text_white d-block mt_36 py_22"
                        style="width: 100%; max-width: 100%"
                    >
                        Review & Pay
                    </button>
                </div>
            </form>
        </div>

        <!-- Pay Via Terms popup-->
        <div
            class="modal login-form-popup fade payViaTerms_popup"
            id="payViaTerms"
            tabindex="-1"
            aria-labelledby="payViaTerms"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div class="modal-dialog modal-dialog-centered modal-dialog">
                <div class="modal-content">
                    <div
                        class="modal-body"
                        style="overflow-y: auto"
                        v-if="termPaymentInfo"
                    >
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close-payViaTerms"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <div
                            class="login-form"
                            v-if="
                                parseFloat(order_data.order_price) >
                                parseFloat(termPaymentInfo.avalaible_on_account)
                            "
                        >
                            <h3>
                                Insufficient Funds
                                <span
                                    class="font-weight-bold"
                                    v-if="
                                        termPaymentInfo.avalaible_on_account >
                                            0 &&
                                        order_data.order_price <=
                                            termPaymentInfo.avalaible_on_account
                                    "
                                >
                                    {{
                                        icPriceFormat(
                                            termPaymentInfo.avalaible_on_account -
                                                order_data.order_price
                                        )
                                    }}
                                </span>
                                <span
                                    class="font-weight-bold"
                                    v-else-if="
                                        termPaymentInfo.avalaible_on_account >
                                            0 &&
                                        order_data.order_price >
                                            termPaymentInfo.avalaible_on_account
                                    "
                                >
                                    {{
                                        icPriceFormat(
                                            order_data.order_price -
                                                termPaymentInfo.avalaible_on_account
                                        )
                                    }}
                                </span>
                                <span class="font-weight-bold" v-else>
                                    {{ icPriceFormat(order_data.order_price) }}
                                </span>
                            </h3>
                            <p class="mb_20">
                                You don't have enough funds to buy this order
                                Please add a card
                            </p>
                            <div
                                class="radio_butoons_headding d-flex mt_0 mb_30 border-top-0 border-bottom"
                                v-for="(
                                    payment_methods, indx
                                ) in all_payment_methods"
                                :key="indx"
                                :style="
                                    payment_methods.expired_time < new Date()
                                        ? 'display:none !important'
                                        : ''
                                "
                            >
                                <p class="m-0">
                                    <input
                                        type="radio"
                                        :value="
                                            payment_methods.customerPaymentProfileId
                                        "
                                        :id="
                                            payment_methods.customerPaymentProfileId +
                                            'id'
                                        "
                                        name="radio-group"
                                        @change="
                                            selectRemainingPaySavedCard(
                                                payment_methods.customerPaymentProfileId,
                                                payment_methods.expired_time,
                                                $event
                                            )
                                        "
                                    />
                                    <label
                                        :for="
                                            payment_methods.customerPaymentProfileId +
                                            'id'
                                        "
                                        class="m-0"
                                    >
                                        **** **** ****
                                        <span class="cc_opa">
                                            {{
                                                payment_methods.payment
                                                    .creditCard.cardNumber
                                                    ? payment_methods.payment.creditCard.cardNumber.substr(
                                                          -4
                                                      )
                                                    : ""
                                            }}
                                        </span>
                                    </label>
                                </p>
                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'Visa'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/add_visa_logo.png'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'MasterCard'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/master_card_logo.png'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'JCB'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/jcb_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'Discover'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/discover_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>
                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'AmericanExpress'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/american_express_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div class="ml-auto mr_6 cards_img" v-else>
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/unknown_card_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>
                            </div>

                            <div
                                class="radio_butoons_headding d-flex mt_0 mb_30 border-top-0 border-bottom"
                            >
                                <p class="m-0">
                                    <label for="test1" class="m-0"
                                        ><span class="cc_opa"
                                            >Credit card</span
                                        ></label
                                    >
                                </p>
                                <img
                                    src="/maincss/images/cards.png"
                                    alt=" "
                                    class="ml-auto mr_6 cards_img"
                                />
                            </div>

                            <form
                                method="POST"
                                data-vv-scope="insufficientForm"
                            >
                                <div class="two_input_one_row mt_36">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="Card Number"
                                            name="CardNumber"
                                            placeholder="Enter Card Number "
                                            :value="
                                                card_info2.cardnumber
                                                    ? '#### #### #### ' +
                                                      card_info2.cardnumber
                                                    : undefined
                                            "
                                            v-validate="'required|length:19'"
                                            data-vv-as="Card Number"
                                            disabled
                                        />

                                        <label class="select_option_label"
                                            >Card number</label
                                        >
                                        <span class="highlight"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'insufficientForm.CardNumber'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "insufficientForm.CardNumber"
                                                )
                                            }}
                                        </small>
                                    </div>

                                    <div
                                        class="card_detail_month_year_code d-flex align-items-baseline justify-content-between mt_18"
                                    >
                                        <div
                                            class="form-group position-relative expiration"
                                        >
                                            <label class="select_option_label"
                                                >Month</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info2.cardexpiremonth
                                                "
                                                name="Expiration Month"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Month"
                                                disabled
                                            >
                                                <option
                                                    v-for="n in 12"
                                                    :value="
                                                        10 > n ? '0' + n : n
                                                    "
                                                    :key="n"
                                                    :disabled="
                                                        n <
                                                            new Date().getMonth() +
                                                                1 &&
                                                        changedYear <=
                                                            currentYear
                                                    "
                                                >
                                                    {{ 10 > n ? "0" + n : n }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Expiration Month'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Expiration Month"
                                                    )
                                                }}
                                            </small>
                                        </div>

                                        <div
                                            class="form-group position-relative expiration"
                                        >
                                            <label class="select_option_label"
                                                >Year</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info2.cardexpireyear
                                                "
                                                name="Expiration Year"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Year"
                                                disabled
                                                @change="changeCardYear($event)"
                                            >
                                                <option
                                                    v-for="year in years"
                                                    :key="year"
                                                    :value="
                                                        year
                                                            ? year
                                                                  .toString()
                                                                  .substr(-2)
                                                            : ''
                                                    "
                                                >
                                                    {{ year }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Expiration Year'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Expiration Year"
                                                    )
                                                }}
                                            </small>
                                        </div>

                                        <div class="form-group securit_code">
                                            <span class="position-relative">
                                                <input
                                                    maxlength="3"
                                                    type="text"
                                                    class="form-control"
                                                    id="Security Code"
                                                    placeholder="236 "
                                                    name="Security Code"
                                                    v-model="
                                                        card_info2.cardsecuritycode
                                                    "
                                                    v-validate="
                                                        'required|numeric|length:3'
                                                    "
                                                    @input="cardSecurityFormate"
                                                />

                                                <div
                                                    class="alert-icon pb-2"
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    v-tooltip="
                                                        'Credit Card Security Code'
                                                    "
                                                >
                                                    <img
                                                        src="/maincss/images/information.svg"
                                                        alt=" "
                                                    />
                                                </div>
                                            </span>
                                            <label class="select_option_label"
                                                >Security code</label
                                            >

                                            <span class="highlight"></span>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Security Code'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Security Code"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="payviaterms_btn_box d-flex align-items-baseline justify-content-end mt_34 mb_0"
                                >
                                    <button
                                        data-dismiss="modal"
                                        class="btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        @click="payRemainingAmount"
                                        class="btn btn_orange bg_primary_orange text_white w-auto ml_20 btn_h60"
                                    >
                                        Pay
                                        <span
                                            v-if="
                                                termPaymentInfo.avalaible_on_account >
                                                    0 &&
                                                order_data.order_price <=
                                                    termPaymentInfo.avalaible_on_account
                                            "
                                        >
                                            {{
                                                icPriceFormat(
                                                    termPaymentInfo.avalaible_on_account -
                                                        order_data.order_price
                                                )
                                            }}
                                        </span>
                                        <span
                                            v-else-if="
                                                termPaymentInfo.avalaible_on_account >
                                                    0 &&
                                                order_data.order_price >
                                                    termPaymentInfo.avalaible_on_account
                                            "
                                        >
                                            {{
                                                icPriceFormat(
                                                    order_data.order_price -
                                                        termPaymentInfo.avalaible_on_account
                                                )
                                            }}
                                        </span>
                                        <span v-else>
                                            {{
                                                icPriceFormat(
                                                    order_data.order_price
                                                )
                                            }}
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ADD NEW PAYMENT MODEL-->
        <div
            class="modal login-form-popup fade h-auto payment_popup"
            id="add_payment_method_model"
            tabindex="-1"
            aria-labelledby="address"
            aria-hidden="true"
            data-keyboard="false"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable payment"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Add New Payment Method</h3>
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close-paymentform"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                    </div>
                    <form
                        method="post"
                        @submit.prevent="addNewPaymentMethod"
                        data-vv-scope="paymentform"
                        :key="'paymentform'"
                    >
                        <div class="modal-body">
                            <div class="address-form">
                                <div class="form-group">
                                    <div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="cardnumber"
                                            name="cardnumber"
                                            placeholder="Enter Card Number"
                                            v-model="card_info.cardnumber"
                                            v-validate="
                                                'required|min:17|max:19'
                                            "
                                            data-vv-as="Card Number"
                                            v-mask="
                                                masklength == null
                                                    ? '#### #### #### #'
                                                    : masklength == 14
                                                    ? '#### #### #### ##'
                                                    : masklength == 15
                                                    ? '#### ###### #####'
                                                    : masklength == 16
                                                    ? '#### #### #### ####'
                                                    : masklength == 17
                                                    ? '#### #### #### ####'
                                                    : '#### #### #### ####'
                                            "
                                            @input="cardNumberFormate"
                                        />
                                    </div>
                                    <label style="margin-top: -20px"
                                        >Card Number</label
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has('paymentform.cardnumber')
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "paymentform.cardnumber"
                                            )
                                        }}
                                    </small>
                                </div>
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="cardholdername"
                                        maxlength="80"
                                        name="cardholdername"
                                        placeholder="Enter Card Holder Name"
                                        v-model="card_info.cardholdername"
                                        v-validate="'required|max:50'"
                                        data-vv-as="Card Holder"
                                    />
                                    <label class="card-holder"
                                        >Card Holder</label
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has(
                                                'paymentform.cardholdername'
                                            )
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "paymentform.cardholdername"
                                            )
                                        }}
                                    </small>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label
                                                style="margin-top: -20px"
                                                class="select_option_label"
                                                >Month</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info.cardexpiremonth
                                                "
                                                name="Expiration Month"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Month"
                                            >
                                                <option
                                                    v-for="n in 12"
                                                    :value="
                                                        10 > n ? '0' + n : n
                                                    "
                                                    :key="n"
                                                    :disabled="
                                                        (n <
                                                            (
                                                                '0' +
                                                                (new Date().getMonth() +
                                                                    1)
                                                            ).slice(-2) &&
                                                            changedYear <=
                                                                currentYear) ||
                                                        card_info.cardexpireyear <
                                                            currentYear
                                                    "
                                                >
                                                    {{ 10 > n ? "0" + n : n }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'paymentform.Expiration Month'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "paymentform.Expiration Month"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label
                                                style="margin-top: -20px"
                                                class="select_option_label"
                                                >Year</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info.cardexpireyear
                                                "
                                                name="Expiration Year"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Year"
                                                @change="changeCardYear($event)"
                                            >
                                                <option
                                                    v-for="year in years"
                                                    :key="year"
                                                    :value="
                                                        year
                                                            .toString()
                                                            .substr(-2)
                                                    "
                                                    :disabled="
                                                        year
                                                            .toString()
                                                            .substr(-2) <
                                                        currentYear
                                                    "
                                                >
                                                    {{ year }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'paymentform.Expiration Year'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "paymentform.Expiration Year"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn_outline_primary border_primary_blue cancel"
                                data-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                class="btn btn_orange bg_primary_orange text_white ml_10 add"
                            >
                                Add
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
    <!-- eslint-enable -->
</template>
<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import ApiService from "@/common/api.service";

export default {
    name: "PaymentShipmentV2",
    directives: { mask },
    components: {},
    props: [
        "order_data",
        "netsuite_customer_data",
        "enableTermPayment",
        "termPaymentInfo"
    ],
    data() {
        return {
            card_info: {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2), //new Date().getMonth() + 1,
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            },
            card_info2: {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2), //new Date().getMonth() + 1,
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            },
            masklength: "",
            base_url: window.location.origin,
            isBusy: false,
            currentYear: new Date().getFullYear().toString().substr(-2), //For Card Expiry Year
            changedYear: "",
            selected_shiping_method: null,
            all_payment_methods: [],
            shippingCarriers: [],
            shipping_methods: [],
            grand_total: "",
            grand_total_price: "",
            shipping_price: "",
            pay_type: null,
            credit_limit: null,
            credit_reduce: null,
            insufficient_amount: null,
            po_number: "",
            is_pay_way_terms: false,
            term_payment_error: ""
        };
    },

    mounted() {
        document.body.classList.add("bg_primary_light_white");

        var _this = this;
        _this.isBusy = false;
        _this.$parent.isLoader = false;
        _this.order_data = _this.$parent.order_data;

        // Reset ALL payment methods to ensure nothing is auto-selected (for all users)
        _this.order_data.is_pay_later = false;
        _this.order_data.is_payvia_terms = 0;
        _this.order_data.is_pay_way_terms = false;
        _this.order_data.is_cod = false;
        _this.order_data.is_saved_card = false;
        _this.order_data.customerPaymentProfileId = "";

        if (_this.$parent && _this.$parent.order_data) {
            _this.$parent.order_data.is_pay_later = false;
            _this.$parent.order_data.is_payvia_terms = 0;
            _this.$parent.order_data.is_pay_way_terms = false;
            _this.$parent.order_data.is_cod = false;
            _this.$parent.order_data.is_saved_card = false;
            _this.$parent.order_data.customerPaymentProfileId = "";
        }

        _this.getAllPaymentMethods();
        _this.getShippingCarriers();

        const dict = {
            custom: {
                CardNumber: {
                    min: "Card Number should atleast 14 digits.",
                    max: "Card Number can not exceed 16 digits."
                },
                PhoneNumber: {
                    length: "Phone Number must be 10 digits."
                }
            }
        };

        _this.$validator.localize("en", dict);

        _this.getCart();
    },

    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "isAdminLoggedIn"
        ]),
        years() {
            const year = new Date().getFullYear();
            return Array.from({ length: 15 }, (value, index) => year + index);
        }
    },
    watch: {
        // Watch for shipping address changes and fetch methods if carrier is set
        "order_data.shippingaddress1": {
            handler() {
                if (
                    this.order_data.shippingproviderid &&
                    this.shippingCarriers.length > 0
                ) {
                    this.$nextTick(() => {
                        this.onShippingCarrierChange();
                    });
                }
            },
            immediate: false,
            deep: true
        },
        "order_data.shippingaddresszip": {
            handler() {
                if (
                    this.order_data.shippingproviderid &&
                    this.shippingCarriers.length > 0
                ) {
                    this.$nextTick(() => {
                        this.onShippingCarrierChange();
                    });
                }
            },
            immediate: false,
            deep: true
        },
        "order_data.shippingproviderid": {
            handler(newVal) {
                if (newVal && this.shippingCarriers.length > 0) {
                    // Wait a bit for address to be available
                    setTimeout(() => {
                        this.onShippingCarrierChange();
                    }, 500);
                }
            },
            immediate: false
        }
    },

    methods: {
        selectDefaultCard() {
            if (this.all_payment_methods) {
                let payment_methods = this.all_payment_methods.filter(
                    (method) => method.expired_time >= new Date()
                );
                if (payment_methods.length) {
                    /* eslint-disable */
                    $(
                        `#${payment_methods[0].customerPaymentProfileId}`
                    ).click();
                    /* eslint-enable */
                    this.singlePaymentMethod(
                        payment_methods[0].customerPaymentProfileId,
                        payment_methods[0].expired_time,
                        true
                    );
                }
            }
        },
        capitalize(value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        calculate_shipping() {
            this.getCart();
            this.$parent.order_data.shippingmethod =
                this.selected_shiping_method.serviceName;
            this.shipping_price = this.selected_shiping_method.total;
            this.grand_total_price =
                parseFloat(this.grand_total) + parseFloat(this.shipping_price);
            this.$parent.selected_shiping_method = this.selected_shiping_method;
        },
        acceptNumber() {
            /* eslint-disable */
            var x = this.order_data.phone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.order_data.phone = !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
            /* eslint-enable */
        },
        acceptShippingNumber() {
            /* eslint-disable */
            var x = this.order_data.shippingphone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.order_data.shippingphone = !x[2]
                ? x[1]
                : "" + x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
            /* eslint-enable */
        },
        cardNumberFormate() {
            if (this.order_data.cardnumber.replace(/\s/g, "").length < 14) {
                this.masklength = "";
            }
            if (this.order_data.cardnumber.replace(/\s/g, "").length == 14) {
                this.masklength = 14;
            }
            if (this.order_data.cardnumber.replace(/\s/g, "").length == 15) {
                this.masklength = 15;
            }
            if (this.order_data.cardnumber.replace(/\s/g, "").length == 16) {
                this.masklength = 16;
            }
            if (this.order_data.cardnumber.replace(/\s/g, "").length > 16) {
                this.masklength = 17;
            }
        },
        cardSecurityFormate() {
            /* eslint-disable */
            var x = this.order_data.cardsecuritycode
                .replace(/\D/g, "")
                .match(/(\d{0,3})/);
            this.order_data.cardsecuritycode = !x[2]
                ? x[1]
                : "" + x[1] + "" + x[2] + (x[3] ? "" + x[3] : "");
            /* eslint-enable */
        },
        changeCardYear(event) {
            var _this = this;
            _this.changedYear = event.target.value;
            if (_this.changedYear == _this.currentYear) {
                _this.order_data.cardexpiremonth = (
                    "0" +
                    (new Date().getMonth() + 1)
                ).slice(-2); //new Date().getMonth() + 1;
            } else {
                _this.order_data.cardexpiremonth = "01";
            }
            _this.card_info.cardexpiremonth = _this.order_data.cardexpiremonth;
        },
        validatePaymentMethod() {
            // Check if at least one payment method is selected
            var _this = this;
            var hasPaymentMethod = false;

            // Check for saved card
            if (
                _this.order_data.is_saved_card &&
                _this.order_data.customerPaymentProfileId
            ) {
                hasPaymentMethod = true;
            }
            // Check for pay via terms
            else if (
                _this.order_data.is_payvia_terms ||
                _this.order_data.is_pay_way_terms
            ) {
                hasPaymentMethod = true;
            }
            // Check for send payment link (pay later)
            else if (_this.order_data.is_pay_later) {
                hasPaymentMethod = true;
            }
            // Check for COD
            else if (_this.order_data.is_cod) {
                hasPaymentMethod = true;
            }

            if (!hasPaymentMethod) {
                _this.$toast.error("Please select a payment method.", {
                    position: "top-right",
                    queue: true
                });
                return false;
            }

            return true;
        },
        proceedToReview() {
            // Simple method to proceed to review after validation
            var _this = this;
            if (!_this.validatePaymentMethod()) {
                return false;
            }

            _this.order_data.po_number = _this.po_number;
            _this.$parent.is_reviewpay = true;
            _this.$parent.is_payment = false;
            _this.$parent.order_data = _this.order_data;

            /* eslint-disable */
            $("html,body").animate(
                {
                    scrollTop: 0
                },
                "slow"
            );
            /* eslint-enable */

            return true;
        },
        payViaCard() {
            var _this = this;

            // Validate payment method is selected
            if (!_this.validatePaymentMethod()) {
                return;
            }

            /* eslint-disable */
            this.order_data.cardexpiredate =
                this.order_data.cardexpiremonth +
                "/" +
                this.order_data.cardexpireyear;
            this.$validator
                .validateAll("shippingandpaymentform")
                .then((isValid) => {
                    if (!isValid) {
                        return;
                    }
                    this.card_info.cardholdername = this.order_data.fullname;
                    this.card_info.cardexpiremonth =
                        this.order_data.cardexpiremonth;
                    this.card_info.cardexpireyear =
                        this.order_data.cardexpireyear;
                    this.card_info.cardnumber = this.order_data.cardnumber;
                    this.order_data.po_number = this.po_number;
                    this.$parent.is_reviewpay = true;
                    this.$parent.is_payment = false;
                    this.$parent.order_data = this.order_data;
                    $("html,body").animate(
                        {
                            scrollTop: 0
                        },
                        "slow"
                    );
                });
            /* eslint-enable */
        },
        payRemainingAmount() {
            if (
                !this.card_info2.cardnumber ||
                !this.card_info2.cardnumber.trim()
            ) {
                this.$toast.error("Please select card.", {
                    position: "top-right",
                    queue: true
                });
                return;
            }
            this.$validator.validateAll("insufficientForm").then((isValid) => {
                if (!isValid) {
                    return;
                }
                /* eslint-disable */
                $("#payViaTerms").modal("hide");
                this.$parent.is_reviewpay = true;
                this.$parent.is_payment = false;
                this.order_data.is_remaining_pay_card = true;
                this.order_data.is_pay_way_terms = true;
                this.order_data.remaining_pay_card_details = this.card_info2;
                /* eslint-enable */
                this.$parent.order_data = this.order_data;
                setTimeout(() => {
                    this.$forceUpdate();
                    this.$parent.$refs.reviewPayComp.$forceUpdate();
                }, 500);
            });
        },
        getAllPaymentMethods() {
            return new Promise((resolve, reject) => {
                ApiService.get("/getAllPaymentMethods")
                    .then(({ data }) => {
                        if (data.all_payment_methods) {
                            this.all_payment_methods = data.all_payment_methods;
                            this.all_payment_methods.forEach((method) => {
                                let expiration_date =
                                    method.payment.creditCard.expirationDate;
                                method.expired_time = new Date(
                                    expiration_date.split("-")[0],
                                    expiration_date.split("-")[1],
                                    0
                                );
                            });
                        }
                        this.isBusy = false;

                        // Ensure no payment method is auto-selected after loading payment methods
                        if (!this.isAdminLoggedIn) {
                            if (
                                this.order_data.is_pay_later ||
                                this.order_data.is_payvia_terms ||
                                this.order_data.is_pay_way_terms
                            ) {
                                if (this.$parent && this.$parent.order_data) {
                                    this.$parent.order_data.is_pay_later = false;
                                    this.$parent.order_data.is_payvia_terms = 0;
                                    this.$parent.order_data.is_pay_way_terms = false;
                                }
                            }
                        }

                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        getShippingCarriers() {
            var _this = this;
            return new Promise((resolve, reject) => {
                ApiService.get("/getShippingCarriers")
                    .then(({ data }) => {
                        if (data.shippingCarriers) {
                            _this.shippingCarriers = data.shippingCarriers;
                            // Set default carrier if available
                            if (
                                _this.shippingCarriers.length > 0 &&
                                !_this.order_data.shippingproviderid
                            ) {
                                _this.order_data.shippingproviderid =
                                    _this.shippingCarriers[0].id;
                            }

                            // Try to fetch methods after a delay to ensure address is loaded
                            setTimeout(() => {
                                if (
                                    _this.order_data.shippingproviderid &&
                                    _this.shippingCarriers.length > 0
                                ) {
                                    _this.onShippingCarrierChange();
                                }
                            }, 1000);
                        }
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        onShippingCarrierChange() {
            var _this = this;
            if (!_this.order_data.shippingproviderid) {
                _this.shipping_methods = [];
                _this.selected_shiping_method = null;
                return;
            }

            // Check if shipping address is available
            if (
                !_this.order_data.shippingaddress1 ||
                !_this.order_data.shippingaddresszip
            ) {
                // Don't show error, just return silently - address might not be set yet
                // Methods will be fetched when address is available
                _this.shipping_methods = [];
                _this.selected_shiping_method = null;
                return;
            }

            _this.isBusy = true;
            const carrierId = parseInt(_this.order_data.shippingproviderid);
            const carrier = _this.shippingCarriers.find(
                (c) => c.id === carrierId
            );

            if (!carrier) {
                _this.isBusy = false;
                return;
            }

            _this.order_data.shipping_provider_name = carrier.shpping_provider;
            _this.order_data.total_weight_in_lbs =
                _this.$parent.total_weight_in_lbs || 0;

            // Call appropriate API based on carrier ID
            if (carrierId == 1) {
                // UPS
                ApiService.post("/getShippingRates/ups", {
                    order_data: _this.order_data
                })
                    .then(async ({ data }) => {
                        if (data.success == true) {
                            _this.shipping_methods = data.result || [];
                            _this.order_data.shippingproviderimage =
                                data.image_url;
                            if (_this.shipping_methods.length > 0) {
                                _this.selected_shiping_method =
                                    _this.shipping_methods[0];
                                _this.calculateShipping();
                            } else {
                                _this.selected_shiping_method = null;
                            }
                        } else {
                            _this.shipping_methods = [];
                            _this.selected_shiping_method = null;
                            _this.$toast.error(
                                data.error || "Failed to get shipping rates",
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                        }
                        _this.isBusy = false;
                    })
                    .catch(() => {
                        _this.shipping_methods = [];
                        _this.selected_shiping_method = null;
                        _this.isBusy = false;
                        _this.$toast.error("Error fetching shipping rates", {
                            position: "top-right",
                            queue: true
                        });
                    });
            } else if (carrierId == 2) {
                // FedEx
                ApiService.post("/getShippingRates/fedex", {
                    shipping_address: {
                        address1: _this.order_data.shippingaddress1,
                        address2: _this.order_data.shippingaddress2,
                        state: _this.order_data.shippingaddressstate,
                        city: _this.order_data.shippingcity,
                        country: _this.order_data.shippingcountry,
                        zipcode: _this.order_data.shippingaddresszip
                    }
                })
                    .then(async ({ data }) => {
                        // FedEx API returns shippingMethods directly in response
                        if (
                            data.shippingMethods &&
                            data.shippingMethods.length > 0
                        ) {
                            _this.shipping_methods = data.shippingMethods;
                            _this.order_data.shippingproviderimage =
                                data.image_url;

                            // Try to find FedEx Ground, otherwise select first method
                            let fedexGround = _this.shipping_methods.find(
                                (method) =>
                                    method.serviceName == "FedEx Ground®"
                            );
                            _this.selected_shiping_method =
                                fedexGround || _this.shipping_methods[0];
                            _this.calculateShipping();
                        } else if (data.result && data.result.shippingMethods) {
                            // Fallback: check if data.result.shippingMethods exists
                            _this.shipping_methods =
                                data.result.shippingMethods;
                            _this.order_data.shippingproviderimage =
                                data.image_url;
                            if (_this.shipping_methods.length > 0) {
                                let fedexGround = _this.shipping_methods.find(
                                    (method) =>
                                        method.serviceName == "FedEx Ground®"
                                );
                                _this.selected_shiping_method =
                                    fedexGround || _this.shipping_methods[0];
                                _this.calculateShipping();
                            } else {
                                _this.selected_shiping_method = null;
                            }
                        } else {
                            _this.shipping_methods = [];
                            _this.selected_shiping_method = null;
                            _this.$toast.error(
                                data.error || "No shipping methods available",
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                        }
                        _this.isBusy = false;
                    })
                    .catch(() => {
                        _this.shipping_methods = [];
                        _this.selected_shiping_method = null;
                        _this.isBusy = false;
                        _this.$toast.error("Error fetching shipping rates", {
                            position: "top-right",
                            queue: true
                        });
                    });
            } else if (carrierId == 3) {
                // USPS
                ApiService.post("/getShippingRates/usps", {
                    order_data: _this.order_data
                })
                    .then(async ({ data }) => {
                        if (data.success == true) {
                            _this.shipping_methods = data.result || [];
                            _this.order_data.shippingproviderimage =
                                data.image_url;
                            if (_this.shipping_methods.length > 0) {
                                _this.selected_shiping_method =
                                    _this.shipping_methods[0];
                                _this.calculateShipping();
                            } else {
                                _this.selected_shiping_method = null;
                            }
                        } else {
                            _this.shipping_methods = [];
                            _this.selected_shiping_method = null;
                            _this.$toast.error(
                                data.error || "Failed to get shipping rates",
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                        }
                        _this.isBusy = false;
                    })
                    .catch(() => {
                        _this.shipping_methods = [];
                        _this.selected_shiping_method = null;
                        _this.isBusy = false;
                        _this.$toast.error("Error fetching shipping rates", {
                            position: "top-right",
                            queue: true
                        });
                    });
            } else {
                _this.isBusy = false;
            }
        },
        calculateShipping() {
            // Calculate shipping price when method is selected
            if (this.selected_shiping_method) {
                this.shipping_price = parseFloat(
                    this.selected_shiping_method.total ||
                        this.selected_shiping_method.totalNetCharge ||
                        0
                );
                const shippingMethod =
                    this.selected_shiping_method.serviceName ||
                    this.selected_shiping_method.serviceType;

                // Update parent's selected_shiping_method so CartSummary can access it
                if (this.$parent && this.$parent.order_data) {
                    this.$parent.selected_shiping_method =
                        this.selected_shiping_method;
                    this.$parent.order_data.shipping_price =
                        this.shipping_price;
                    this.$parent.order_data.shippingmethod = shippingMethod;
                }
            } else {
                // Clear shipping method if none selected
                if (this.$parent) {
                    this.$parent.selected_shiping_method = null;
                }
            }
        },
        singlePaymentMethod(id, expiredtime, event) {
            var _this = this;
            _this.term_payment_error = "";
            if (expiredtime < new Date()) {
                event.target.checked = false;
                _this.order_data.is_saved_card = false;
                _this.order_data.customerProfileId = "";
                _this.order_data.customerPaymentProfileId = "";
                _this.order_data.cardtype = "";
                _this.order_data.cardsecuritycode = "";
                _this.order_data.cardnumber = "";
                _this.order_data.cardexpiremonth = (
                    "0" +
                    (new Date().getMonth() + 1)
                ).slice(-2);
                _this.order_data.cardexpireyear = new Date()
                    .getFullYear()
                    .toString()
                    .substr(-2);
                _this.$toast.error("This card has expired", {
                    position: "top-right",
                    queue: true
                });
                _this.$validator.reset();
                _this.$forceUpdate();
                return;
            }
            _this.order_data.is_payvia_terms = 0;

            _this.isBusy = true;
            new Promise(() => {
                ApiService.get("/getSinglePaymentMethod/" + id)
                    .then(({ data }) => {
                        _this.order_data.is_saved_card = true;
                        _this.order_data.is_pay_way_terms = false;
                        _this.order_data.is_remaining_pay_card = false;
                        _this.order_data.is_cod = false;
                        _this.order_data.is_pay_later = false;
                        _this.order_data.customerProfileId =
                            data.payment_method.customerProfileId;
                        _this.order_data.customerPaymentProfileId =
                            data.payment_method.customerPaymentProfileId;
                        _this.order_data.cardtype =
                            data.payment_method.payment.creditCard.cardType;
                        _this.order_data.cardsecuritycode = "";
                        _this.$validator.reset();
                        _this.order_data.cardnumber = data.payment_method
                            .payment.creditCard.cardNumber
                            ? data.payment_method.payment.creditCard.cardNumber
                                  .substr(-4)
                                  .replace(/\s/g, "")
                            : "";
                        _this.order_data.cardexpiremonth =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[1]
                                .trim();
                        _this.order_data.cardexpireyear =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[0]
                                .split(/(.{2})/)
                                .filter((x) => x.length == 2)[1]
                                .trim();

                        // Also update parent's order_data to ensure reactivity
                        if (_this.$parent && _this.$parent.order_data) {
                            _this.$parent.order_data.is_saved_card = true;
                            _this.$parent.order_data.is_pay_way_terms = false;
                            _this.$parent.order_data.is_cod = false;
                            _this.$parent.order_data.is_pay_later = false;
                            _this.$parent.order_data.customerPaymentProfileId =
                                _this.order_data.customerPaymentProfileId;
                            _this.$parent.order_data.cardtype =
                                _this.order_data.cardtype;
                            _this.$parent.order_data.cardnumber =
                                _this.order_data.cardnumber;
                        }

                        _this.isBusy = false;
                    })
                    .catch(({ response }) => {
                        /* eslint-disable */
                        context.commit(SET_ERROR, response.data.errors);
                        /* eslint-enable */
                    });
            });
        },
        selectRemainingPaySavedCard(id, expiredtime, event) {
            var _this = this;
            _this.term_payment_error = "";
            if (expiredtime < new Date()) {
                event.target.checked = false;
                _this.card_info2 = {
                    id: "",
                    cardtype: "",
                    cardimage: "",
                    cardnumber: "",
                    cardholdername: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2),
                    customerPaymentProfileId: "",
                    customerProfileId: "",
                    cardsecuritycode: ""
                };
                _this.$toast.error("This card has expired", {
                    position: "top-right",
                    queue: true
                });
                _this.$validator.reset();
                _this.$forceUpdate();
                return;
            }
            _this.isBusy = true;
            new Promise(() => {
                ApiService.get("/getSinglePaymentMethod/" + id)
                    .then(({ data }) => {
                        _this.order_data.is_remaining_pay_card = false;
                        _this.card_info2.customerProfileId =
                            data.payment_method.customerProfileId;
                        _this.card_info2.customerPaymentProfileId =
                            data.payment_method.customerPaymentProfileId;
                        _this.card_info2.cardtype =
                            data.payment_method.payment.creditCard.cardType;
                        _this.card_info2.cardsecuritycode = "";
                        _this.$validator.reset();
                        _this.card_info2.cardnumber = data.payment_method
                            .payment.creditCard.cardNumber
                            ? data.payment_method.payment.creditCard.cardNumber
                                  .substr(-4)
                                  .replace(/\s/g, "")
                            : "";
                        _this.card_info2.cardexpiremonth =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[1]
                                .trim();
                        _this.card_info2.cardexpireyear =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[0]
                                .split(/(.{2})/)
                                .filter((x) => x.length == 2)[1]
                                .trim();
                        _this.card_info2.cardexpiredate =
                            _this.card_info2.cardexpiremonth +
                            "/" +
                            _this.card_info2.cardexpireyear;
                        _this.isBusy = false;
                    })
                    .catch(({ response }) => {
                        /* eslint-disable */
                        context.commit(SET_ERROR, response.data.errors);
                        /* eslint-enable */
                    });
            });
        },
        newCard() {
            var _this = this;
            if (_this.$parent && _this.$parent.order_data) {
                _this.$parent.order_data.is_payvia_terms = 0;
            }
            _this.placeorder_add_card = true;
            _this.$validator.reset();
            _this.order_data.is_saved_card = false;
            _this.order_data.cardnumber = "";
            _this.order_data.cardexpiremonth = (
                "0" +
                (new Date().getMonth() + 1)
            ).slice(-2); //new Date().getMonth() + 1;
            _this.order_data.cardexpireyear = new Date()
                .getFullYear()
                .toString()
                .substr(-2);
        },

        setGiftCardNumber(event) {
            var _this = this;
            let value = event.target.value;
            _this.$parent.order_data.giftcardnumber = value;
        },

        setGiftCardPin(event) {
            var _this = this;
            let value = event.target.value;
            _this.$parent.order_data.giftcardpin = value;
        },

        setSpecialComment(event) {
            var _this = this;
            let value = event.target.value;
            _this.$parent.order_data.specialcomment = value;
        },

        setCouponCode(event) {
            var _this = this;
            let value = event.target.value;
            _this.$parent.order_data.couponcode = value;
        },
        async getCart() {
            var _this = this;
            if (_this.isAuthenticatedClient) {
                await ApiService.get("/cart-new")
                    .then(({ data }) => {
                        if (data.success == false) {
                            _this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            _this.isBusy = false;
                            _this.$parent.isLoader = false;
                            return false;
                        }
                        _this.cart_items = data.cart_items;
                        _this.grand_total = data.total_price;
                        _this.$parent.order_data.items = data.cart_items;
                        _this.$parent.order_data.grand_total = data.total_price;

                        // After cart is loaded, if carrier is set and address is available, fetch shipping methods
                        _this.$nextTick(() => {
                            if (
                                _this.order_data.shippingproviderid &&
                                _this.shippingCarriers.length > 0 &&
                                _this.order_data.shippingaddress1 &&
                                _this.order_data.shippingaddresszip
                            ) {
                                _this.onShippingCarrierChange();
                            }
                        });

                        if (data.cart_items.length > 0) {
                            localStorage.setItem("cartNotEmpty", true);
                            _this.cartNotEmpty = true;
                        } else {
                            localStorage.setItem("cartNotEmpty", false);
                            _this.cartNotEmpty = false;
                        }
                        _this.isBusy = false;
                        // calculate total weight in lbs
                        if (_this.cart_items.length > 0) {
                            let total_weight = 0;
                            _this.cart_items.forEach((item) => {
                                item.CartChildItems.forEach((child_item) => {
                                    total_weight =
                                        total_weight +
                                        child_item.main_new_sub_product
                                            .product_weight *
                                            child_item.total_quantity;
                                });
                            });
                            _this.$parent.total_weight_in_lbs =
                                total_weight.toFixed(2);
                        }
                        _this.$parent.isLoader = false;
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            } else {
                if (localStorage.getItem("cart")) {
                    _this.cart_items = JSON.parse(localStorage.getItem("cart"));
                } else {
                    _this.cart_items = [];
                }
            }
        },
        addNewPaymentMethod() {
            var _this = this;
            _this.$validator.validateAll("paymentform").then((isValid) => {
                if (isValid) {
                    var _this = this;
                    _this.isBusy = true;
                    new Promise(() => {
                        ApiService.post("/addPaymentMethod", _this.card_info)
                            .then(async ({ data }) => {
                                if (
                                    data.message ==
                                    "Payment method added successfully."
                                ) {
                                    console.log(_this.card_info);
                                    document
                                        .getElementById(
                                            "popup-close-paymentform"
                                        )
                                        .click();
                                    _this.$toast.success(data.message, {
                                        position: "top-right"
                                    });
                                    await _this.getAllPaymentMethods();
                                    setTimeout(() => {
                                        _this.selectDefaultCard();
                                    }, 1000);

                                    _this.card_info.cardnumber = null;
                                    _this.card_info.cardholdername = null;
                                    _this.card_info.cardexpiremonth = (
                                        "0" +
                                        (new Date().getMonth() + 1)
                                    ).slice(-2);
                                    _this.card_info.cardexpireyear =
                                        this.currentYear;
                                    _this.$validator.reset();
                                } else {
                                    _this.$toast.error(data.message, {
                                        position: "top-right"
                                    });
                                }

                                if (data.error) {
                                    _this.$toast.error(data.error, {
                                        position: "top-right"
                                    });
                                }

                                _this.$forceUpdate();
                                _this.isBusy = false;
                            })
                            .catch((response) => {
                                console.log(response);
                                _this.isBusy = false;
                                if (response.status == 401) {
                                    _this.$router.push({
                                        name: "/admin/login"
                                    });
                                }
                            });
                    });
                }
            });
        },
        selectPaymentOption(option) {
            /* eslint-disable */
            var _this = this;

            // Always update parent's order_data first (source of truth)
            if (!_this.$parent || !_this.$parent.order_data) {
                return;
            }

            if (option == "pay_way_terms") {
                _this.is_pay_way_terms = true;
                _this.$parent.order_data.is_pay_way_terms = true;
                _this.$parent.order_data.is_saved_card = false;
                _this.$parent.order_data.is_cod = false;
                _this.$parent.order_data.is_pay_later = false;
                _this.$parent.order_data.customerProfileId = "";
                _this.$parent.order_data.customerPaymentProfileId = "";
                _this.$parent.order_data.cardtype = "";
                _this.$parent.order_data.cardsecuritycode = "";
                _this.$parent.order_data.cardnumber = "";
                _this.$parent.order_data.cardexpiremonth = (
                    "0" +
                    (new Date().getMonth() + 1)
                ).slice(-2);
                _this.$parent.order_data.cardexpireyear = new Date()
                    .getFullYear()
                    .toString()
                    .substr(-2);

                // Also update local order_data prop
                _this.order_data.is_pay_way_terms = true;
                _this.order_data.is_saved_card = false;
                _this.order_data.is_cod = false;
                _this.order_data.is_pay_later = false;
                _this.order_data.customerPaymentProfileId = "";
                _this.order_data.cardnumber = "";

                _this.$validator.reset();
            } else if (option == "pay_later") {
                _this.is_pay_way_terms = false;
                _this.$parent.order_data.is_pay_way_terms = false;
                _this.$parent.order_data.is_saved_card = false;
                _this.$parent.order_data.is_cod = false;
                _this.$parent.order_data.is_pay_later = true;
                _this.$parent.order_data.customerPaymentProfileId = "";
                _this.$parent.order_data.cardnumber = "";

                // Also update local order_data prop
                _this.order_data.is_pay_way_terms = false;
                _this.order_data.is_saved_card = false;
                _this.order_data.is_cod = false;
                _this.order_data.is_pay_later = true;
                _this.order_data.customerPaymentProfileId = "";
                _this.order_data.cardnumber = "";
            } else if (option == "cod") {
                _this.is_pay_way_terms = false;
                _this.$parent.order_data.is_pay_way_terms = false;
                _this.$parent.order_data.is_saved_card = false;
                _this.$parent.order_data.is_cod = true;
                _this.$parent.order_data.is_pay_later = false;
                _this.$parent.order_data.customerPaymentProfileId = "";
                _this.$parent.order_data.cardnumber = "";

                // Also update local order_data prop
                _this.order_data.is_pay_way_terms = false;
                _this.order_data.is_saved_card = false;
                _this.order_data.is_cod = true;
                _this.order_data.is_pay_later = false;
                _this.order_data.customerPaymentProfileId = "";
                _this.order_data.cardnumber = "";
            }
            /* eslint-enable */
            _this.$forceUpdate();
        },
        payViaTerms() {
            let balance_after_order =
                parseFloat(this.termPaymentInfo.avalaible_on_account) -
                parseFloat(this.order_data.order_price);
            /* eslint-disable */
            if (balance_after_order < 1) {
                $("#payViaTerms").modal("show");
                return;
            }
            this.$parent.is_reviewpay = true;
            this.$parent.is_payment = false;
            this.$parent.order_data = this.order_data;
            $("html,body").animate(
                {
                    scrollTop: 0
                },
                "slow"
            );
            /* eslint-enable */
        }
    }
};
</script>
